import React, { Fragment, useEffect, useState } from 'react';

import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid';

import api from '../../lib/api';
import { CurrentUser } from '../calendar/Calendar';
import { useMedia } from 'react-use';
import { Dialog, Combobox, Transition } from '@headlessui/react';
import { showToast } from '../shared/Toast';
import { url_api_v1_sb_profile_add } from '../../lib/apiUrl';
import submissionBoardService from '../services/SubmissionBoardService';
import projectService from '../services/ProjectService';
import { SbCurrentUser } from './component/SbModel';
import { PlusIcon, XIcon } from 'lucide-react';

export interface SbProfileSelectorProps {
  currentUser: SbCurrentUser;
  projects?: any;
  user: any;
  from?: string; // from sbprofile or sb or sk
  submissionBoardModel?: any; // from sb board
  project?: any; // from sb board
  dialogCloseHandler?: (open: boolean) => void;
  profileSelected?: (profileInfo: any) => void;
  alreadyInSb?: boolean;
  hideButton?: boolean;
}
// called from users profile details for SB creator
// to select a give profile or not. Ask project and SB name.
export default function SbProfileSelector({
  currentUser,
  projects,
  user,
  from,
  project,
  submissionBoardModel,
  alreadyInSb,
  dialogCloseHandler,
  profileSelected,
  hideButton
}: SbProfileSelectorProps) {
  const [showDialog, setShowDialog] = useState(false);
  const [submissionBoards, setSubmissionBoards] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedSubmissionBoard, setSelectedSubmissionBoard] = useState(null);
  const [notes, setNotes] = useState('');
  const [myProjects, setMyProjects] = useState(undefined);

  const isMobileScreen = useMedia('(max-width: 1024px)', false);
  const [isAlreadyInSb, setIsAlreadyInSb] = useState(alreadyInSb ?? false);
  useEffect(() => {
    if (from !== undefined && (from == 'sbprofile' || from == 'sb')) {
      if (from == 'sbprofile' && hideButton == true) {
        handleShowDialog();
      }
      if (
        submissionBoardModel == undefined ||
        submissionBoardModel == null ||
        project == undefined ||
        project == null
      ) {
        return;
      }
      setSelectedSubmissionBoard(submissionBoardModel);
      setSelectedProject(project);
      if (from == 'sbprofile') {
        handleShowDialog();
      }
    }
  }, [submissionBoardModel]);
  useEffect(() => {
    async function fetchProjects() {
      try {
        const _projects = await projectService.getProjects("?sb=1");
        setMyProjects(_projects);
      } catch (error) {
        showToast('Error while fetching submission boards.', 'danger');
      }
    }
    if ((myProjects == undefined) && (from == 'sk' || from == 'sbprofile')) {
      // fetch projects
      console.log('projects undefined -----------------------------------------');
      fetchProjects();
      return;
    }
  }, [myProjects]);

  useEffect(() => {
    async function fetchSubmissionBoards() {
      try {
        if (!selectedProject) return;
        const resp = await submissionBoardService.getSubmissionBoards(
          selectedProject.uuid,
          1,
          999999,
          '',
          '',
          '',
          'open,pending_review'
        );
        const { submission_boards } = resp;
        setSubmissionBoards(submission_boards);
      } catch (error) {
        showToast('Error while fetching submission boards.', 'danger');
      }
    }
    if (from == undefined || from == 'sk' || from == 'sbprofile') {
      setSubmissionBoards([]);
      setSelectedSubmissionBoard(null);
      fetchSubmissionBoards();
    }
  }, [selectedProject]);

  const handleShowDialog = () => {
    setShowDialog(true);
  };

  const handleHideDialog = () => {
    if (from !== 'sb') {
      setSelectedProject(null);
      setSelectedSubmissionBoard(null);
    }
    if (dialogCloseHandler) {
      dialogCloseHandler(false);
    }
    setShowDialog(false);
  };
  const saveClickHandler = async () => {
    try {
      if (
        selectedProject == undefined ||
        selectedProject == null ||
        selectedSubmissionBoard == undefined ||
        selectedSubmissionBoard == null
      ) {
        throw new Error('Error: Invalid data selection.');
      }
      const url = url_api_v1_sb_profile_add
        .replace(':project_uuid', selectedProject.uuid)
        .replace(':sb_id', selectedSubmissionBoard.id); // `/api/v1/submission_boards/${submissionBoard.id}/shortlist_profile`;
      console.log(selectedSubmissionBoard, selectedProject);
      const response = await api.post(url, {
        project_id: selectedProject.uuid,
        submission_board_id: selectedSubmissionBoard.id,
        profile_id: user.id,
        notes: notes,
      });
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error short listing profile.');
      }
      if (profileSelected) {
        await profileSelected({
          project_id: selectedProject.uuid,
          submission_board_id: selectedSubmissionBoard.id,
          profile_id: user.id,
          notes: notes,
        });
      }
      setIsAlreadyInSb(true);
      showToast('Shortlisted ' + (user?.first_name ?? ''), 'success');
      handleHideDialog();
    } catch (error) {
      console.error('Error shortlisting profile:', error);
      var errorMsg = error.response?.data?.error;
      showToast(errorMsg ?? 'Failed to shortlist, please try again', 'danger');
    }
  };

  const ProjectsCombobox = () => {
    const [query, setQuery] = useState('');

    function classNames(...classes) {
      return classes.filter(Boolean).join(' ');
    }
    const filteredPeople =
      query === ''
        ? myProjects ?? []
        : (myProjects ?? []).filter((person) => {
          return person.title.toLowerCase().includes(query.toLowerCase());
        });
    return (
      <>
        <Combobox value={selectedProject} onChange={setSelectedProject}>
          <div className="relative mt-1">
            {/* <div className="relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2 focus-visible:ring-offset-teal-300 sm:text-sm"> */}
            <Combobox.Button as="div" className="w-full">
              <Combobox.Input
                className="outline-none block w-full rounded-md border-0 px-3 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 sm:text-sm sm:leading-6 focus:ring-2 focus:ring-inset focus:ring-blue-500"
                //                className="w-full border-none py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 focus:ring-0"
                placeholder='Select a project...'
                displayValue={(person: any) => person?.title}
                onChange={(event) => setQuery(event.target.value)}
              />
              <div className="absolute inset-y-0 right-0 flex items-center pr-2">
                <ChevronUpDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
              </div>
            </Combobox.Button>
            {/* </div> */}
            <Transition
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
              afterLeave={() => setQuery('')}
            >
              <Combobox.Options className="z-20 absolute w-full border empty:invisible h-32 overflow-y-scroll bg-white">
                {filteredPeople.length === 0 && query !== '' ? (
                  <div className="relative cursor-default select-none px-4 py-2 text-gray-700">
                    Nothing found.
                  </div>
                ) : (
                  filteredPeople.map((person) => (
                    <Combobox.Option
                      key={person.id}
                      className={({ active }) =>
                        classNames(
                          'relative cursor-default select-none py-2 pl-10 pr-9',
                          active ? 'bg-blue-200 text-black' : 'text-gray-700'
                        )
                      }
                      value={person}
                    >
                      {({ selected, active }) => (
                        <>
                          <span className={`block  ${selected ? 'font-medium' : 'font-normal'}`}>
                            {person.title}
                          </span>
                          {selected ? (
                            <span
                              className={`absolute inset-y-0 left-0 flex items-center pl-3 ${active ? 'text-white' : 'text-teal-600'
                                }`}
                            >
                              <CheckIcon className="h-5 w-5" aria-hidden="true" />
                            </span>
                          ) : null}
                        </>
                      )}
                    </Combobox.Option>
                  ))
                )}
              </Combobox.Options>
            </Transition>
          </div>
        </Combobox>
      </>
    );
  };
  const SbCombobox = () => {
    const [query, setQuery] = useState('');

    function classNames(...classes) {
      return classes.filter(Boolean).join(' ');
    }
    const filteredItems =
      query === ''
        ? submissionBoards
        : submissionBoards.filter((item) => {
          return item.title.toLowerCase().includes(query.toLowerCase());
        });
    return (
      <>
        <Combobox value={selectedSubmissionBoard} onChange={setSelectedSubmissionBoard}>
          <div className="relative mt-1">
            {/* <div className="relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2 focus-visible:ring-offset-teal-300 sm:text-sm"> */}
            <Combobox.Button as="div" className="w-full">
              <Combobox.Input
                className="outline-none block w-full rounded-md border-0 px-3 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 sm:text-sm sm:leading-6 focus:ring-2 focus:ring-inset focus:ring-blue-500"
                //                className="w-full border-none py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 focus:ring-0"
                placeholder='Select a submission board...'
                displayValue={(person: any) => person?.title}
                onChange={(event) => setQuery(event.target.value)}
              />
              <div className="absolute inset-y-0 right-0 flex items-center pr-2">
                <ChevronUpDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
              </div>
            </Combobox.Button>
            {/* </div> */}
            <Transition
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
              afterLeave={() => setQuery('')}
            >
              <Combobox.Options className="z-20 absolute w-full border empty:invisible h-32 overflow-y-scroll bg-white">
                {filteredItems.length === 0 && query !== '' ? (
                  <div className="relative cursor-default select-none px-4 py-2 text-gray-700">
                    Nothing found.
                  </div>
                ) : (
                  filteredItems.map((person) => (
                    <Combobox.Option
                      key={person.id}
                      className={({ active }) =>
                        classNames(
                          'relative cursor-default select-none py-2 pl-10 pr-9',
                          active ? 'bg-blue-200 text-black' : 'text-gray-700'
                        )
                      }
                      value={person}
                    >
                      {({ selected, active }) => (
                        <>
                          <span className={`block ${selected ? 'font-medium' : 'font-normal'}`}>
                            {person.title}
                          </span>
                          {selected ? (
                            <span
                              className={`absolute inset-y-0 left-0 flex items-center pl-3 ${active ? 'text-white' : 'text-teal-600'
                                }`}
                            >
                              <CheckIcon className="h-5 w-5" aria-hidden="true" />
                            </span>
                          ) : null}
                        </>
                      )}
                    </Combobox.Option>
                  ))
                )}
              </Combobox.Options>
            </Transition>
          </div>
        </Combobox>
      </>
    );
  };

  return (
    <div className='flex flex-col w-full py-2 '>
      {!isAlreadyInSb && (from == undefined || from == 'sb' || from == 'sbprofile' || from == 'sk') && (
        <div
          className="gap-2-1 flex flex-row cursor-pointer bg-blue-500 text-white rounded-md px-4 py-3 shadow-sm hover:bg-blue-600 text-sm leading-5 font-medium my-2 mx-4"
          onClick={() => {
            handleShowDialog();
          }}
        >
          <PlusIcon className="h-6 w-6" />
          <div className="flex justify-center items-center">Add to Submission Board</div>
        </div>
      )}
      <Transition.Root show={showDialog} as={Fragment}>
        <Dialog as="div" className="relative" style={{ zIndex: 70 }} onClose={handleHideDialog}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-customGray" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center m-6 text-left">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="relative flex flex-col h-full overflow-hidden bg-white rounded-md shadow-xl-0-19-40-8 w-full sm:max-w-md">
                  <div className="overflow-y-auto flex flex-col items-center">
                    <div className="w-full gap-2 flex flex-col items-center justify-between px-4 sm:px-10 py-5">
                      <div className="w-full flex items-center justify-between">
                        <div className="text-lg font-medium text-black">Add to Submission Board</div>
                        <button
                          className="flex items-center justify-center text-gray-700 hover:text-gray-600 transition-colors h-6 w-6"
                          onClick={() => {
                            handleHideDialog();
                          }}
                        >
                          <XIcon className="w-6 h-6" />
                        </button>
                      </div>
                      <div className="text-gray-600 text-sm">Select the project and submission board where you want to submit this perfomer.</div>
                    </div>
                    <div
                      className="justify-items-center flex flex-col px-4 sm:px-10 pb-10 gap-4 max-w-md w-full"
                      style={{ minHeight: '16rem' }}
                    >
                      <hr className="" />
                      {(from == undefined || from == 'sk' || from == 'sbprofile') && (
                        <div className="gap-2-1 flex flex-col text-left">
                          <div className="flex flex-col gap-1">
                            <label
                              htmlFor="title"
                              className="block text-left text-xs font-medium text-gray-900"
                            >
                              Project
                            </label>
                            <ProjectsCombobox />
                          </div>

                          {selectedProject && (
                            <div className="flex flex-col gap-1 text-left">
                              <label
                                htmlFor="title"
                                className="block text-left text-xs font-medium text-gray-900"
                              >
                                Submission Board
                              </label>
                              <SbCombobox />
                            </div>
                          )}
                        </div>
                      )}

                      <div className="flex w-full flex-col pt-2 text-left text-xl leading-8 md:text-2xl md:leading-9 font-semibold text-gray-900">
                        {selectedProject && selectedSubmissionBoard && (
                          <>
                            <label
                              htmlFor="notes"
                              className="pt-2 block text-xs font-medium text-gray-900"
                            >
                              Notes (optional)
                            </label>
                            <textarea
                              name={'notes'}
                              rows={4}
                              id={'shortlist_notes_id'}
                              value={notes}
                              className="outline-none block w-full rounded-md border-0 px-3 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 sm:text-sm sm:leading-6 focus:ring-2 focus:ring-inset focus:ring-blue-500"
                              placeholder={'notes'}
                              onChange={(e) => {
                                if (e.target.value.length > 512) {
                                  showToast('You can add max 512 characters.', 'danger');
                                  return;
                                }
                                setNotes(e.target.value);
                              }}
                            />
                          </>
                        )}
                      </div>

                      <div className="text-center">
                        <>
                          <button
                            type="button"
                            id={'shortlist_cancel_button_id'}
                            className="py-2 px-4 inline-flex items-center border text-sm rounded-md shadow-sm bg-white    hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 cursor-pointer"
                            onClick={() => {
                              handleHideDialog();
                            }}
                          >
                            {'Cancel'}
                          </button>
                          {selectedProject && selectedSubmissionBoard && (
                            <button
                              id={'shortlist_button_id'}
                              type="button"
                              className="ml-2 py-2 px-4 rounded text-sm bg-blue-500 text-white hover:bg-blue-600 transition-all duration-100 ease-in"
                              onClick={() => {
                                saveClickHandler();
                              }}
                            >
                              {'Add To Board'}
                            </button>
                          )}
                        </>
                      </div>
                    </div>
                  </div>
                  {/* </Dialog> */}
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
}
